import type { ParagraphThreeColsTextImages as ParagraphThreeColsTextImagesData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import {
  PARAGRAPH_THREE_COLS_TEXT_TEXT_PHOTO_LAYOUT,
  PARAGRAPH_THREE_COLS_TEXT_PHOTO_TEXT_LAYOUT,
  PARAGRAPH_THREE_COLS_PHOTO_TEXT_TEXT_LAYOUT,
} from "@/lib/cms/paragraphLayouts";
import { HtmlText } from "../shared/HtmlText";
import { ImageGallery } from "../shared/ImageGallery";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layouts 8/9/10 — 3 kolumny z różną pozycją obrazów:
 *   - 8  (TEXT_TEXT_PHOTO) — col1=text|name, col2=text_1|name_1, col3=images
 *   - 9  (TEXT_PHOTO_TEXT) — col1=text|name, col2=images,        col3=text_1|name_1
 *   - 10 (PHOTO_TEXT_TEXT) — col1=images,    col2=text|name,     col3=text_1|name_1
 */
export function ParagraphThreeColsTextImages({
  paragraph,
  t,
}: {
  paragraph: ParagraphThreeColsTextImagesData;
  t: ParagraphTranslations;
}) {
  const col1Text = (
    <>
      {paragraph.name && (
        <h2 className={styles.paragraphSubName}>{paragraph.name}</h2>
      )}
      <HtmlText html={paragraph.text} />
    </>
  );
  const col2Text = (
    <>
      {paragraph.name_1 && (
        <h2 className={styles.paragraphSubName}>{paragraph.name_1}</h2>
      )}
      <HtmlText html={paragraph.text_1} />
    </>
  );
  const images = <ImageGallery images={paragraph.images} t={t} />;

  return (
    <section className={styles.paragraph}>
      <div className={styles.colsThree}>{renderCols(paragraph.layout, col1Text, col2Text, images)}</div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}

function renderCols(
  layout: ParagraphThreeColsTextImagesData["layout"],
  text1: React.ReactNode,
  text2: React.ReactNode,
  images: React.ReactNode,
) {
  switch (layout) {
    case PARAGRAPH_THREE_COLS_TEXT_TEXT_PHOTO_LAYOUT:
      return (
        <>
          <div>{text1}</div>
          <div>{text2}</div>
          <div>{images}</div>
        </>
      );
    case PARAGRAPH_THREE_COLS_TEXT_PHOTO_TEXT_LAYOUT:
      return (
        <>
          <div>{text1}</div>
          <div>{images}</div>
          <div>{text2}</div>
        </>
      );
    case PARAGRAPH_THREE_COLS_PHOTO_TEXT_TEXT_LAYOUT:
      return (
        <>
          <div>{images}</div>
          <div>{text1}</div>
          <div>{text2}</div>
        </>
      );
    default:
      return null;
  }
}
